import axios from 'axios';
import { ContractType } from '../external/components/Icon/Icon';

export const BINANCE_SUBGRAPH_URL =
  'https://api.thegraph.com/subgraphs/name/spaceforce-dev/staking-legacy';

export const POLYGON_SUBGRAPH_URL =
  'https://api.thegraph.com/subgraphs/name/mantradao/mantra-dao-staking-polygon';

export const ETH_LEGACY_STAKING_SUBGRAPH_URL =
  'https://api.thegraph.com/subgraphs/name/mantradao/eth-staking-subgraph-legacy';

export const BSC_LEGACY_STAKING_SUBGRAPH_URL =
  'https://api.thegraph.com/subgraphs/name/senidcurt/milc-bsc-staking';

export const BSC_TESTNET_LEGACY_STAKING_SUBGRAPH_URL =
  'https://api.studio.thegraph.com/query/52305/bsc-test-milc-staking/3.18';

export const POLY_LEGACY_STAKING_SUBGRAPH_URL =
  'https://api.thegraph.com/subgraphs/name/mantradao/mantra-dao-staking-polygon';
// 'https://api.thegraph.com/subgraphs/name/mantradao/polygon-staking-subgraph-legacy';

export const ITEMS_PER_QUERY = 1000;

export interface StakingStats {
  tokenSymbol: ContractType;
  tokensStaked: string;
}

export async function getEthStakingStats(url: string): Promise<StakingStats[]> {
  const { data } = await axios.post(url, {
    query: `
    {
      stakingPools {
        tokensStaked
        tokenSymbol
      }
    }    
    `,
  });

  const response = data.data.stakingPools.filter((data: any) => data.token !== 'unknown');

  return response;
}

export const getTransfersPastLogsFromBinance = async (
  token: string,
  first: number,
  skip: number = 0,
  url: string = BINANCE_SUBGRAPH_URL,
) => {
  const { data: response } = await axios.post(`${url}`, {
    query: `
        {
          transfers(first: ${first}, skip: ${skip}, orderBy: logIndex, orderDirection: asc, where: {token: "${token}"}) {
            from
            to
            value
            blockNumber
            logIndex
            token
          }
        }
      `,
  });
  return response.data;
};

export const getPricesPastLogsFromBinance = async (
  token: string,
  first: number,
  skip: number = 0,
  url: string = BINANCE_SUBGRAPH_URL,
) => {
  const { data: response } = await axios.post(`${url}`, {
    query: `
        {
          priceUpdates(first: ${first}, skip: ${skip}, orderBy: blockNumber, orderDirection: asc, where: {token: "${token}"}) {
            id
            mantissa
            exponentiation
            base
            blockNumber
            token
          }
        }
      `,
  });
  return response.data;
};

export const getAllTransfersLogs = async (token: string, url?: string) => {
  const total: object[] = [];
  let currentSkip = 0;
  await (async function recursiveGetdata() {
    const { transfers } = await getTransfersPastLogsFromBinance(
      token,
      ITEMS_PER_QUERY,
      currentSkip,
      url,
    );
    currentSkip += ITEMS_PER_QUERY;
    total.push(...transfers);

    if (transfers.length === ITEMS_PER_QUERY) {
      await recursiveGetdata();
    } else {
      return;
    }
  })();
  return total;
};

export const getAllPricesLogs = async (token: string, url?: string) => {
  const total: object[] = [];
  let currentSkip = 0;
  await (async function recursiveGetdata() {
    const { priceUpdates } = await getPricesPastLogsFromBinance(
      token,
      ITEMS_PER_QUERY,
      currentSkip,
      url,
    );
    currentSkip += ITEMS_PER_QUERY;
    total.push(...priceUpdates);

    if (priceUpdates.length === ITEMS_PER_QUERY) {
      await recursiveGetdata();
    } else {
      return;
    }
  })();
  return total;
};
